import { useEffect, useState } from "react";
import { Megaphone, Star } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { PageHero, Reveal, EmptyState, formatDate } from "@/components/public/Shared";

export default function Announcements() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/public/announcements").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="announcements-page">
      <PageHero title="Announcements" subtitle="News and important updates from the church office." />
      <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24">
        {items && items.length === 0 && (
          <EmptyState testId="announcements-empty" title="No announcements yet" text="Church announcements will be published here." />
        )}
        <div className="space-y-6">
          {(items || []).map((a, i) => (
            <Reveal key={a.id} delay={i * 0.05}>
              <article className="rounded-lg border border-border bg-white p-8 shadow-sm" data-testid={`announcement-${a.id}`}>
                <div className="flex flex-wrap items-center gap-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
                  <span className="flex items-center gap-1.5"><Megaphone className="h-4 w-4 text-gold" /> {formatDate(a.date)}</span>
                  {a.category && <span className="rounded-full bg-secondary px-3 py-0.5 text-navy/70">{a.category}</span>}
                  {a.featured && <span className="flex items-center gap-1 text-gold-dark"><Star className="h-3.5 w-3.5 fill-gold text-gold" /> Featured</span>}
                </div>
                <h2 className="mt-3 font-heading text-2xl font-bold text-navy">{a.title}</h2>
                {a.image_url && (
                  <img src={fileUrl(a.image_url)} alt={a.title} className="mt-4 max-h-72 w-full rounded-md object-cover" loading="lazy" />
                )}
                <p className="mt-4 text-sm leading-relaxed text-foreground/80 whitespace-pre-line">{a.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
